// extracted by mini-css-extract-plugin
export default {"privacy-policy":"PrivacyPolicy_privacy-policy__D2H5s","banner-heading":"PrivacyPolicy_banner-heading__iExXw"};